module.exports = __webpack_public_path__ + "media/MRI18C 2.19a09b44.mp3";